module.exports = __webpack_public_path__ + "static/suite_008-97a2e6784fd87b24e0a463f8ad58803a.jpg";